<div class="multi-download-attachment">
  <a *ngIf="attachments?.length > 1" role="button" tabindex="0" (click)="openModalAction()">
    <i class="icon icon--docs icon--medium"></i>
    <p>{{ attachments?.length }} documentos anexados</p>
  </a>

  <div *ngIf="attachments?.length === 1">
    <app-download-attachment
      [viewModel]="attachments[0]"
      displayType="small"
      (clickItem)="clickAttachment(attachments[0])"
    >
    </app-download-attachment>
  </div>

  <ng-template #templateModalAttachments>
    <div class="wrapper-modal">
      <h1>Anexos</h1>

      <div class="wrapper-modal-content">
        <div class="attachment-item" *ngFor="let item of attachments">
          <app-download-attachment [viewModel]="item" (clickItem)="clickAttachment(item)" displayType="small">
          </app-download-attachment>
        </div>
      </div>
    </div>
  </ng-template>
</div>
